<template>
	<div>
		<header-page
			:title="$route.meta.title"
			to-show
			:show-excel="false"
			@on-clean="cleanFilter"
		/>
		<action-bar
			:value-disabled="valuesDisabled"
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		></action-bar>
		<general-filter class="layout wrap align-center mt-4">
			<v-flex xs12 md2 px-2>
				<base-select
					item-text="name"
					item-value="id"
					label="Reporte"
					:height="32"
					:items="reports"
					v-model="report"
					:return-object="true"
					@input="changeSelect('report', $event)"
				/>
			</v-flex>
			<v-flex xs12 md2 px-2 v-if="report.code === 'accounting-book'">
				<base-select
					item-text="name"
					item-value="id"
					label="Origen del asiento"
					:height="32"
					:items="modules"
					v-model="typeRegisterId"
					:return-object="true"
					@input="changeModule('modules', $event)"
				/>
			</v-flex>
			<v-flex
				xs12
				readonly
				md2
				px-2
				class="my-2"
				v-if="report.code === 'major-general'"
			>
				<!--<accounting-searcher
					class="searcher-accounting"
					:account="account.account"
					:account-name="account.name"
					place-holder="Cuenta Inicial"
					@open-searcher="openSearcher"
				></accounting-searcher>-->
				<div class="accounting-searcher">
					<v-text-field
						key="input"
						hide-details
						readonly
						background-color="white"
						class="base-input"
						height="32"
						label="Cuenta Inicial"
						@click="getOpenSearcher"
						append-icon="search"
						v-model="startAccount.fullName"
					/>
				</div>
				<!--	<base-select
					autocomplete
					item-text="fullName"
					item-value="id"
					label="Cuenta Inicial"
					:height="38"
					:items="accounts"
					v-model="startAccount"
					:return-object="true"
				/>-->
			</v-flex>
			<v-flex
				xs12
				md2
				aria-readonly="readonly"
				px-2
				v-if="report.code === 'major-general'"
			>
				<!-- <accounting-searcher
					class="searcher-accounting"
					:account="accountFinally.account"
					place-holder="Cuenta Final"
					:account-name="accountFinally.name"
					@open-searcher="openSearcherFinally"
				></accounting-searcher> -->
				<div class="accounting-searcher">
					<v-text-field
						key="input"
						hide-details
						background-color="white"
						class="base-input"
						height="32"
						readonly
						label="Cuenta Final"
						@click="getOpenSearcherFinally"
						append-icon="search"
						v-model="endAccount.fullName"
					/>
				</div>
				<!-- <base-select
					autocomplete
					item-text="fullName"
					item-value="id"
					label="Cuenta Final"
					:height="38"
					:items="accounts"
					v-model="endAccount"
					:return-object="true"
				/> -->
			</v-flex>
			<v-flex xs12 md2 px-2 v-if="report.code === 'result-status'">
				<base-select
					item-text="level"
					item-value="id"
					label="Tipo"
					:height="32"
					:items="typesReport"
					v-model="selectedTypeBalance"
					@input="changeSelectTipe($event)"
				/>
			</v-flex>
			<v-flex
				xs12
				md2
				px-2
				v-if="
					report.code === 'balance-sheet' || report.code === 'result-status'
				"
			>
				<base-select
					item-text="level"
					item-value="id"
					label="Nivel"
					:height="32"
					:items="levels"
					v-model="levelId"
					@input="changeSelectLevel('levelId', $event)"
				/>
			</v-flex>
			<v-flex
				xs12
				md2
				px-2
				v-if="
					report.code === 'balance-sheet' || report.code === 'result-status'
				"
			>
				<base-select
					item-text="name"
					item-value="id"
					label="Centro de Costo"
					:height="32"
					:items="costcenters"
					v-model="costCenterId"
					:return-object="true"
					@input="getCenterCost($event)"
				/>
			</v-flex>
			<v-flex xs12 md2 px-2 v-if="report.code !== 'balance-sheet'">
				<BaseSelect
					item-text="name"
					item-value="id"
					:height="32"
					label="Fecha"
					v-model="typeDateId"
					:items="typesDate"
					@input="getDataDate($event)"
				/>
			</v-flex>
			<v-flex xs12 md2 px-2 v-if="flagDate && report.code !== 'balance-sheet'">
				<span class="captionDate">Fecha Desde</span>
				<date-component
					round
					:date="params.startDate"
					icon="/static/img/calendar.svg"
					@on-input="setDate({ model: 'startDate', value: $event })"
				></date-component>
			</v-flex>
			<v-flex xs12 md2 px-2 v-if="flagDate">
				<span class="captionDate">{{ nameInputDate }}</span>
				<date-component
					round
					:date="params.endDate"
					icon="/static/img/calendar.svg"
					@on-input="setDate({ model: 'endDate', value: $event })"
				></date-component>
			</v-flex>
			<v-flex xs12 md2 px-2 pt-3 data-tooltip="VISUALIZAR EN TABLA">
				<v-btn
					:disabled="isLoading || !verifySubsidiary"
					color="#2196f3"
					block
					class="btn-report"
					@click="downloadReport('preview')"
				>
					<v-icon>
						image_search
					</v-icon>
					Visualizar en Tabla
				</v-btn>
			</v-flex>
			<v-flex xs12 md2 px-2 pt-3 data-tooltip="DESCARGAR PDF">
				<v-btn
					:disabled="isLoading || !verifySubsidiary"
					color="#77a1d1"
					block
					class="btn-report"
					@click="downloadReport('download')"
				>
					<v-icon>
						file_download
					</v-icon>
					Descargar PDF
				</v-btn>
			</v-flex>
			<v-flex xs12 md2 px-2 pt-3 data-tooltip="DESCARGAR EXCEL" v-if="this.selectedTypeBalance !== 2">
				<v-btn
					:disabled="isLoading || !verifySubsidiary"
					color="#02979b"
					block
					class="btn-report"
					@click="downloadReportExcel()"
				>
					<img src="/static/img/actions-list/excel.svg" />
					Descargar Excel
				</v-btn>
			</v-flex>
			<v-flex xs12 md2 px-2 pt-3 data-tooltip="DESCARGAR EXCEL" v-if="this.report.code === 'result-status' && this.selectedTypeBalance === 2">
				<v-btn
					:disabled="isLoading || !verifySubsidiary"
					color="#02979b"
					block
					class="btn-report"
					@click="downloadReportExcel(true)"
				>
					<img src="/static/img/actions-list/excel.svg" />
					Descargar Excel Agrupado
				</v-btn>
			</v-flex>
		</general-filter>
		<v-layout row wrap justify-between>
			<v-flex
				:class="validateComponenteTable ? 'xs12' : 'xs12 md6'"
				v-if="showComponentTable"
			>
				<div v-if="code === 'balance-sheet'" class="mx-5 my-3">
					<accountant-table-tree
						:columns="columnsBalance"
						:rows="results"
						:code-reports="code"
					>
					</accountant-table-tree>
					<div class="total-table">
						<v-layout wrap>
							<v-flex
								v-for="column in columnsTotalBalance"
								:key="column.id"
								:class="[
									{
										'title-table': column.name === 'title',
										'total-row': column.name !== 'title',
									},
									column.class,
								]"
							>
								{{ formatData(totalIncomeStatement[column.name]) }}
							</v-flex>
						</v-layout>
					</div>
					<div class="total-table">
						<v-layout wrap>
							<v-flex
								v-for="column in columnsTotalBalance"
								:key="column.id"
								:class="[
									{
										'title-table': column.name === 'title',
										'total-row': column.name !== 'title',
									},
									column.class,
								]"
							>
								{{ formatData(totalBalance[column.name]) }}
							</v-flex>
						</v-layout>
					</div>
				</div>
				<div v-else-if="code === 'checking-balance'" class="mx-5 my-3">
					<accountant-table-tree
						:columns="columnsCheckingBalance"
						:rows="resultsChecking"
						:code-reports="code"
					>
					</accountant-table-tree>
					<div class="total-table">
						<v-layout wrap>
							<v-flex
								v-for="column in columnsTotalCheckingBalance"
								:key="column.id"
								:class="[
									{
										'title-table': column.name === 'title',
										'total-row': column.name !== 'title',
									},
									column.class,
								]"
							>
								{{ formatData(totalResultChecking[column.name]) }}
							</v-flex>
						</v-layout>
					</div>
				</div>
				<div v-else-if="code === 'accounting-book'" class="mx-5 my-3">
					<app-table
						:rows="results"
						:columns="columnsAccountingBook"
						:last-page="lastPage"
						:current-page="currentPage"
						@on-page="changePage"
						@on-search-event="onSearch"
					>
						<template slot="rows" slot-scope="props">
							<td v-show="showRow(columnsAccountingBook, 1)">
								{{ props.row.date | exactDate }}
							</td>
							<td v-show="showRow(columnsAccountingBook, 2)">
								{{ props.row.code }}
							</td>
							<td v-show="showRow(columnsAccountingBook, 3)" class="gloss">
								<p class="mb-0">
									<span class="desktop">Descripción: </span>
									<span v-if="props.row.gloss && !mobile">
										<span v-if="props.row.gloss.length < 17">{{
											props.row.gloss
										}}</span>
										<v-tooltip top v-else>
											<span slot="activator">{{ props.row.gloss }} </span>
											<span>{{ props.row.gloss }} </span>
										</v-tooltip>
									</span>
									<span v-else>
										{{ props.row.gloss }}
									</span>
								</p>
							</td>
							<td v-show="showRow(columnsAccountingBook, 4)">
								<app-tooltip-button
									color="blue"
									icon="remove_red_eye"
									text="Ver Detalle"
									:width="17"
									@click-icon="openDetail(props.row)"
								/>
							</td>
						</template>
					</app-table>
				</div>
				<div v-else-if="code === 'major-general'" class="mx-5 my-3">
					<app-table
						:rows="results"
						:columns="columnsMajorGeneral"
						:last-page="lastPage"
						:current-page="currentPage"
						@on-page="changePage"
						@on-search-event="onSearch"
					>
						<template slot="rows" slot-scope="props">
							<td v-show="showRow(columnsMajorGeneral, 1)">
								{{ props.row.accountingCode }}
							</td>
							<td v-show="showRow(columnsMajorGeneral, 2)">
								{{ props.row.description }}
							</td>
							<td v-show="showRow(columnsMajorGeneral, 3)">
								<app-tooltip-button
									color="blue"
									icon="remove_red_eye"
									text="Ver Detalle"
									:width="17"
									@click-icon="openDetailMajor(props.row)"
								/>
							</td>
						</template>
					</app-table>
				</div>
				<div
					v-else-if="code === 'result-status' && selectedTypeBalance === 1"
					class="mx-5 my-3"
				>
					<accountant-table-tree
						:columns="columnsIncomeStatement"
						:rows="results"
						:code-reports="code"
					>
					</accountant-table-tree>
					<div class="total-table">
						<v-layout wrap>
							<v-flex
								v-for="column in columnsTotalIncomeStatement"
								:key="column.id"
								:class="[
									{
										'title-table': column.name === 'title',
										'total-row': column.name !== 'title',
									},
									column.class,
								]"
							>
								{{ formatData(totalIncomeStatement[column.name]) }}
							</v-flex>
						</v-layout>
					</div>
				</div>
				<div
					v-else-if="
						report.code === 'result-status' &&
							selectedTypeBalance === 2 &&
							flagMonthBalance
					"
					class="mx-5 my-3"
				>
					<balance-sheet-month :accountsData="periodData" />
				</div>
			</v-flex>
			<v-flex
				:class="validateComponenteTable ? 'xs12' : 'xs12 md6'"
				px-4
				pt-4
				v-show="showComponentPdf"
			>
				<div
					v-show="!showMssg"
					ref="viewer"
					id="result"
					class="hidden-sm-and-down"
				></div>
				<div class="container-mssg" v-if="showMssg">
					<p>Para ver el PDF, haz clic en el botón "Descargar PDF".</p>
				</div>
			</v-flex>
		</v-layout>
		<v-dialog
			v-model="dialogDetailAccounting"
			max-width="850"
			persistent
			v-if="dialogDetailAccounting"
		>
			<v-toolbar color="primary" dark>
				<v-toolbar-title class="v-dialog-title white--text">
					<v-layout>
						<v-flex xs6 pa-1 class="content-text">Libro Diario</v-flex>
					</v-layout>
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn
					class="custom-btn"
					small
					icon
					@click="dialogDetailAccounting = false"
				>
					<v-icon size="16">close</v-icon>
				</v-btn>
			</v-toolbar>
			<app-table
				:rows="rowsDetailModal"
				:columns="columnsDetail"
				:input-search="false"
				:created-add="false"
			>
				<template slot="rows" slot-scope="props">
					<td v-show="showRow(columnsDetail, 1)">
						{{
							props.row.accountingAccount !== null
								? props.row.accountingAccount.account
								: null
						}}
					</td>
					<td v-show="showRow(columnsDetail, 2)">
						{{ props.row.accountingAccount.name }}
					</td>
					<td v-show="showRow(columnsDetail, 3)" class="reference">
						<p class="mb-0">
							<span class="desktop">Referencia: </span>
							<span v-if="props.row.reference && !mobile">
								<span v-if="props.row.reference.length < 17"
									>{{ props.row.reference }}
								</span>
								<v-tooltip top v-else>
									<span slot="activator">{{ props.row.reference }} </span>
									<span>{{ props.row.reference }} </span>
								</v-tooltip>
							</span>
							<span v-else>
								{{ props.row.reference }}
							</span>
						</p>
					</td>
					<td class="text-xs-right pr-1" v-show="showRow(columnsDetail, 4)">
						{{ props.row.amountDebe | formatAmount }}
					</td>
					<td class="text-xs-right pr-1" v-show="showRow(columnsDetail, 5)">
						{{ props.row.amountHaber | formatAmount }}
					</td>
				</template>
			</app-table>
		</v-dialog>
<v-dialog
	v-model="dialogDetailAccountingMajor"
	max-width="1280"
	persistent
>
	<div class="mayor-dialog">

		<!-- ============ CABECERA ============ -->
		<div class="mayor-header">
			<div>
				<div class="mayor-title">Mayor General</div>
				<div class="mayor-subtitle">Detalle de movimientos de la cuenta contable</div>
			</div>
			<button type="button" class="mayor-close" @click="closeDialog">&times;</button>
		</div>

		<!-- ============ CUENTA + TOTALES ============ -->
		<div class="mayor-resumen">
			<div class="mayor-cuenta">
				<div class="mayor-cuenta__icono">
					<v-icon color="white" size="26">account_balance</v-icon>
				</div>
				<div class="mayor-cuenta__datos">
					<span class="mayor-etiqueta">Código</span>
					<span class="mayor-cuenta__codigo">{{ majorGeneralCode }}</span>
					<span class="mayor-etiqueta">Cuenta</span>
					<span class="mayor-cuenta__nombre" :title="majorGeneralDescription">
						{{ majorGeneralDescription }}
					</span>
					<span class="mayor-etiqueta">Saldo al</span>
					<span class="mayor-cuenta__detalle">{{ previousDate }}</span>
				</div>
			</div>

			<div class="mayor-kpis">
				<div class="mayor-kpi">
					<span class="mayor-etiqueta">Saldo inicial</span>
					<span class="mayor-kpi__valor" :class="claseMonto(saldoInicialMajor)">
						{{ saldoInicialMajor | formatAmount }}
					</span>
				</div>
				<div class="mayor-kpi">
					<span class="mayor-etiqueta">Suma débitos</span>
					<span class="mayor-kpi__valor mayor-positivo">
						{{ sumaDebitosMajor | formatAmount }}
					</span>
				</div>
				<div class="mayor-kpi">
					<span class="mayor-etiqueta">Suma créditos</span>
					<span class="mayor-kpi__valor mayor-positivo">
						{{ sumaCreditosMajor | formatAmount }}
					</span>
				</div>
				<div class="mayor-kpi mayor-kpi--final">
					<span class="mayor-etiqueta">Saldo final</span>
					<span class="mayor-kpi__valor" :class="claseMonto(saldoFinalMajor)">
						{{ saldoFinalMajor | formatAmount }}
					</span>
				</div>
			</div>
		</div>

		<!-- ============ FILTROS ============ -->
		<div class="mayor-filtros">

			<div class="mayor-campo mayor-campo--buscar">
				<span class="mayor-etiqueta">Buscar</span>
				<div class="mayor-control">
					<input
						type="text"
						v-model="searchMajor"
						placeholder="Buscar por asiento, referencia o descripción...">
					<v-icon>search</v-icon>
				</div>
			</div>

			<div class="mayor-campo">
				<span class="mayor-etiqueta">Ver</span>
				<div class="mayor-control mayor-control--ver">
					<select v-model="filterMajor">
						<option value="todos">Todos</option>
						<option value="debitos">Solo débitos</option>
						<option value="creditos">Solo créditos</option>
					</select>
				</div>
			</div>

				<div class="mayor-acciones">
				<button type="button" class="mayor-btn mayor-btn--linea" @click="exportarMayor">
					<v-icon>file_download</v-icon>
					Exportar
				</button>
				<button type="button" class="mayor-btn mayor-btn--solido" @click="imprimirMayor">
					<v-icon>print</v-icon>
					Imprimir
				</button>
			</div>
		</div>

		<!-- ============ TABLA ============ -->
		<div class="mayor-tabla">
			<div class="mayor-thead" :class="claseGridMajor">
				<div class="mayor-celda">Fecha</div>
				<div class="mayor-celda">Asiento</div>
				<div class="mayor-celda">Referencia</div>
				<div v-if="hayDescripcionMajor" class="mayor-celda">Descripción</div>
				<div class="mayor-celda mayor-celda--num">Débito</div>
				<div class="mayor-celda mayor-celda--num">Crédito</div>
				<div class="mayor-celda mayor-celda--num">Saldo corriente</div>
			</div>

			<div class="mayor-tbody">
				<div class="mayor-fila mayor-fila--inicial" :class="claseGridMajor">
					<div class="mayor-celda">
						<span class="mayor-fecha-inicial">{{ previousDate }}</span>
					</div>
					<div class="mayor-celda">SALDO INICIAL</div>
					<div class="mayor-celda">-</div>
					<div v-if="hayDescripcionMajor" class="mayor-celda">
						<span class="mayor-texto">Saldo inicial al {{ previousDate }}</span>
					</div>
					<div class="mayor-celda mayor-celda--num">{{ 0 | formatAmount }}</div>
					<div class="mayor-celda mayor-celda--num">{{ 0 | formatAmount }}</div>
					<div
						class="mayor-celda mayor-celda--num mayor-celda--saldo"
						:class="claseMonto(saldoInicialMajor)">
						{{ saldoInicialMajor | formatAmount }}
					</div>
				</div>

				<div
					v-for="(item, index) in rowsMajorFiltradas"
					:key="index"
					class="mayor-fila"
					:class="claseGridMajor"
				>
					<div class="mayor-celda">{{ item.date | exactDate }}</div>
					<div class="mayor-celda">
						<span class="mayor-texto mayor-asiento" :title="item.seat">{{ item.seat }}</span>
					</div>
					<div class="mayor-celda">
						<span class="mayor-texto" :title="item.reference">{{ item.reference }}</span>
					</div>
					<div v-if="hayDescripcionMajor" class="mayor-celda">
						<span class="mayor-texto" :title="descripcionMajor(item)">
							{{ descripcionMajor(item) }}
						</span>
					</div>
					<div class="mayor-celda mayor-celda--num">{{ item.debit | formatAmount }}</div>
					<div class="mayor-celda mayor-celda--num">{{ item.credit | formatAmount }}</div>
					<div
						class="mayor-celda mayor-celda--num mayor-celda--saldo"
						:class="claseMonto(item.balance)">
						{{ item.balance | formatAmount }}
					</div>
				</div>

				<div v-if="rowsMajorFiltradas.length === 0" class="mayor-vacio">
					<v-icon size="30" color="#c2cbd4">search_off</v-icon>
					<div>No existen movimientos para esta cuenta</div>
				</div>
			</div>

			<div class="mayor-conteo">
				Mostrando {{ rowsMajorFiltradas.length }} de {{ totalRowsMajor }} registros
			</div>
		</div>

		<!-- ============ RESUMEN ============ -->
		<div class="mayor-resumen-pie">

			<div class="mayor-caja">
				<span class="mayor-etiqueta">Saldo inicial</span>
				<span class="mayor-caja__valor" :class="claseMonto(saldoInicialMajor)">
					{{ saldoInicialMajor | formatAmount }}
				</span>
			</div>
			<div class="mayor-operacion">+</div>
			<div class="mayor-caja">
				<span class="mayor-etiqueta">Suma débitos</span>
				<span class="mayor-caja__valor mayor-positivo">
					{{ sumaDebitosMajor | formatAmount }}
				</span>
			</div>
			<div class="mayor-operacion">&minus;</div>
			<div class="mayor-caja">
				<span class="mayor-etiqueta">Suma créditos</span>
				<span class="mayor-caja__valor mayor-positivo">
					{{ sumaCreditosMajor | formatAmount }}
				</span>
			</div>
			<div class="mayor-operacion">=</div>
			<div class="mayor-caja mayor-caja--final">
				<span class="mayor-etiqueta">Saldo final</span>
				<span class="mayor-caja__valor" :class="claseMonto(saldoFinalMajor)">
					{{ saldoFinalMajor | formatAmount }}
				</span>
			</div>
		</div>

		<div class="mayor-nota">
			<div class="mayor-nota__izq">
				<v-icon>info_outline</v-icon>
				Los saldos están expresados en la moneda del sistema.
			</div>
			<div class="mayor-formula">
				<span>Ver fórmula:</span>
				<span>Saldo Final =</span>
				<span :class="claseMonto(saldoInicialMajor)">Saldo Inicial</span>
				<span>+</span>
				<span class="mayor-positivo">Suma Débitos</span>
				<span>&minus;</span>
				<span class="mayor-positivo">Suma Créditos</span>
			</div>
		</div>

	</div>
</v-dialog>
		<action-sidebar
			:title="action.title"
			:value="action.value"
			:width="action.width"
			@close-modal="closeModal"
		>
			<slide-searcher
				v-if="isActionCode('searcher')"
				:columns="columnsAccount"
				:current-page="currentPageSearcher"
				:last-page="lastPageSearcher"
				:rows="accounts"
				text-btn="Seleccionar"
				:search="params.search"
				@add-record="addRecord"
				@on-close="closeModal"
				@on-page="changePageAccount"
				@on-search="onSearchRecords"
			/>
			<slide-searcher
				v-if="isActionCode('searcherFinally')"
				:columns="columnsAccount"
				:current-page="currentPageSearcher"
				:last-page="lastPageSearcher"
				:rows="accounts"
				text-btn="Seleccionar"
				@add-record="addRecordFinally"
				@on-close="closeModal"
				@on-page="changePage"
				@on-search="onSearchRecords"
			/>
		</action-sidebar>
	</div>
</template>

<script>
import appDateSelect from '@/components/shared/app-date-select';
import actionBar from '@/components/shared/action-bar/action-bar';
import accountingSearcher from '@/components/shared/searcher/accounting-searcher';
import helper from '@/shared/helper';
import actionSidebar from '@/components/shared/action-sidebar';
import headerPage from '@/components/shared/header-page';
import generalFilter from '@/components/shared/general-filter';
import BaseSelect from '@/components/shared/inputs/base-select';
import appTable from '@/components/shared/table/app-table';
import slideSearcher from '@/components/shared/searcher/slide-searcher';
import tableMayor from '@/components/shared/table/table-mayor';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import accountantTableTree from '@/components/accountant/accountant-table-tree';
import balanceSheetMonth from '@/components/records/balance-sheet-month';
import { mapGetters } from 'vuex';
import dateComponent from '@/components/autocomplete/date-component';
import { endOfMonth, format, subDays } from 'date-fns';

function created() {
	this.report = this.reports.find(r => r.id === 1);
	this.levelId = 9;
	this.params.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
	this.params.endDate = this.$today;
	if (Object.entries(this.currentSubsidiary).length !== 0) {
		this.subsidiary = { ...this.currentSubsidiary };
	} else {
		this.showNotification('Debe seleccionar una empresa', 'warning');
	}
	this.getDataDate(4);
	this.loadModules();
	this.loadCostCenter();
}
function addRecord(record) {
	this.account = { ...record };
	this.startAccount = this.account;
	this.accountFinally = { ...record };
	this.endAccount = this.accountFinally;
	localStorage.setItem('quipu::Acount', this.account.id);
	this.action.value = false;
	this.action.title = '';
	this.action.code = '';
}
function addRecordFinally(record) {
	this.accountFinally = { ...record };
	this.endAccount = this.accountFinally;
	localStorage.setItem('quipu::Acount', this.account.id);
	this.action.value = false;
	this.action.title = '';
	this.action.code = '';
}
async function loadAccounts(page = 1) {
	this.currentPageSearcher = page;
	this.paramsRecords.page = this.currentPageSearcher;
	const subId = JSON.parse(localStorage.getItem('cs'));
	try {
		const params = {
			subsidiaryId: this.subsidiary.id,
			limit: this.paramsRecords.limit,
			page: this.paramsRecords.page,
			search: this.paramsRecords.search,
		};
		const { data: records, headers } = await this.$http.get(
			// `accounting-plan/${subId.id}/subsidiary?flag=false`, { params });
			`accounting-plan/${subId.id}/subsidiary?status=1`, { params });
		this.accounts = records;
		this.lastPageSearcher = Number(headers['x-last-page']);
	} catch (error) {
		this.showGenericError('No existen cuentas para filtrar');
	}
}

async function loadModules() {
	const params = { subsidiaryId: this.subsidiary.id };
	({ data: this.modules } = await this.$http.get('type-register', { params }));
	const index = this.modules.findIndex(m => m.id === this.typeRegisterId);
	this.typeRegisterId = index > -1 ? this.typeRegisterId : null;
}

function setDate({ model, value }) {
	if (model === 'startDate') {
		this.params[model] = format(value, 'YYYY-MM-DD');
		this.params.endDate = format(endOfMonth(value), 'YYYY-MM-DD');
	} else if (model === 'endDate') {
		this.params[model] = format(value, 'YYYY-MM-DD');
	}
}

function onSearchRecords(search) {
	this.paramsRecords.search = search.trim() ? search.trim() : null;
	this.loadAccounts();
}

function cleanFilter() {
	// this.params.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
	// this.params.endDate = this.$today;
	this.params.status = null;
	this.params.limit = 10;
	this.paramsRecords.search = null;
	this.params.typeRegisterId = null;
	this.typeRegisterId = null;
	this.accountFinally = {};
	this.account = {};
	this.paramsRecords.page = 1;
	this.page = 1;
	// this.report = this.reports.find(r => r.id === 1);
	this.levelId = 9;
	this.code = '';
	this.costCenterId = null;
	this.params.costCenterId = null;
	this.startAccount.fullName = null;
	this.endAccount.fullName = null;
}

function getDataDate(val) {
	this.typeDateId = val;
	if (val === 1) {
		this.params.startDate = this.$today;
		this.params.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 2) {
		this.params.startDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.params.endDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.flagDate = false;
	} else if (val === 3) {
		this.params.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.params.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 4) {
		const today = new Date(this.$today);
		const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		this.params.startDate = firstDayOfMonth.toISOString().split('T')[0];
		this.params.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 5) {
		const today = new Date(this.$today);
		// Set the startDate to the first day of the current year
		const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
		this.params.startDate = firstDayOfYear.toISOString().split('T')[0];
		this.params.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 6) {
		this.params.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.params.endDate = this.$today;
		this.flagDate = true;
	}
}

function openDetail(row) {
	this.dialogDetailAccounting = true;
	this.rowsDetailModal = row.details;
}

function openDetailMajor(row) {
	this.majorGeneralCode = `${row.accountingCode}`;
	this.majorGeneralDescription = `${row.description}`;
	this.balanceMajor = row.balance.toFixed(2);
	this.previousBalance = row.previousBalance.toFixed(2);
	this.previousDate = `${row.previousDate}`;
	this.dialogDetailAccountingMajor = true;
	this.rowsDetailModalMajor = row.details.map((item) => {
		const newItem = { ...item };
		if (item.balance === null || item.balance === undefined) {
			newItem.balance = 0;
		}
		if (item.credit === null || item.credit === undefined) {
			newItem.credit = 0;
		}
		if (item.debit === null || item.debit === undefined) {
			newItem.debit = 0;
		}
		return newItem;
	});
}

function deleteParams() {
	delete this.params.account;
	delete this.params.level;
	delete this.params.flagPrevius;
	delete this.params.limit;
	delete this.params.startAccount;
	delete this.params.endAccount;
}

async function loadData() {
	try {
		if (this.report.code === 'balance-sheet') {
			this.deleteParams();
			delete this.params.startDate;
			delete this.params.page;
			this.params.account = '3';
			this.params.level = this.levelId;
			this.params.costCenterId = this.costCenterId;
			const { data: response } = await this.$http.get('balance-sheet', {
				params: this.params,
			});
			this.typeCode = this.report.code;
			this.code = this.report.code;
			this.results = response;
			this.deleteParams();
			this.params.account = '4';
			this.params.level = this.levelId;
			this.params.costCenterId = this.costCenterId;
			delete this.params.page;
			const { data: responseR } = await this.$http.get('balance-sheet', {
				params: this.params,
			});
			const values = (responseR || []).filter(r => r.fatherAccount === null);
			const fathersBalance = (response || []).filter(f => f.fatherAccount === null);
			// Si Pasivo (2) o Patrimonio (3) no tienen movimiento no vienen en la respuesta: valen 0.
			const balanceOf = account => (account && Number(account.balance)) || 0;
			const patrimNeto = fathersBalance.find(f => f.code === '3');
			const pasive = fathersBalance.find(f => f.code === '2');
			const totalBalance = values.reduce(
				(total, item) => total + balanceOf(item),
				0,
			);
			this.totalIncomeStatement = {
				title: 'Resultado del Periodo',
				totalResult: totalBalance,
			};
			const subtotal = totalBalance + balanceOf(patrimNeto);
			this.totalBalance = {
				title: 'Total Pasivo + Patrimonio',
				totalResult: balanceOf(pasive) + subtotal,
			};
		} else if (this.report.code === 'checking-balance') {
			this.deleteParams();
			delete this.params.page;
			const { data: response } = await this.$http.get('trial-balance', {
				params: this.params,
			});
			this.typeCode = this.report.code;
			this.code = this.report.code;
			this.resultsChecking = response;
			const totalValues = this.resultsChecking.filter(
				v => v.fatherAccount === null,
			);
			this.totalResultChecking = totalValues.reduce(
				(total, acum) => ({
					title: 'Resultado del Ejercicio',
					totalDebit: total.totalDebit + (acum.debit || 0),
					totalCredit: total.totalCredit + (acum.credit || 0),
					totalDebitBalance: total.totalDebitBalance + (acum.debitBalance || 0),
					totalCreditBalance:
						total.totalCreditBalance + (acum.creditBalance || 0),
					totalPreviousBalance:
						total.totalPreviousBalance + (acum.previousBalance || 0),
				}),
				{
					title: 'Resultado del Ejercicio',
					totalDebit: 0,
					totalCredit: 0,
					totalDebitBalance: 0,
					totalCreditBalance: 0,
					totalPreviousBalance: 0,
				},
			);
		} else if (this.report.code === 'accounting-book') {
			this.deleteParams();
			this.params.limit = 10;
			this.params.status = '1';
			this.params.typeRegisterId = this.typeRegisterId || null;
			const {
				data: response,
				headers,
			} = await this.$http.get('accounting-seats', { params: this.params });
			this.lastPage = Number(headers['x-last-page']);
			this.totalItems = Number(headers['x-quantity']);
			this.typeCode = this.report.code;
			this.code = this.report.code;
			this.results = response;
		} else if (this.report.code === 'major-general') {
			this.deleteParams();
			delete this.params.page;
			this.params.startAccount = this.startAccount
				? this.startAccount.account
				: null;
			this.params.endAccount = this.endAccount ? this.endAccount.account : null;
			const { data: response, headers } = await this.$http.get(
				'major-general',
				{ params: this.params },
			);
			this.lastPage = Number(headers['x-last-page']);
			this.totalItems = Number(headers['x-quantity']);
			this.typeCode = this.report.code;
			this.code = this.report.code;
			this.results = response;
		} else if (
			this.report.code === 'result-status' &&
			this.selectedTypeBalance === 1
		) {
			this.deleteParams();
			this.params.account = '4';
			this.params.level = this.levelId;
			this.params.costCenterId = this.costCenterId;
			delete this.params.page;
			const { data: response } = await this.$http.get('balance-sheet', {
				params: this.params,
			});
			this.typeCode = this.report.code;
			this.code = this.report.code;
			this.results = response;
			const totalValues = this.results.filter(v => v.fatherAccount === null);
			this.totalIncomeStatement = totalValues.reduce(
				(total, acum) => ({
					title: 'Resultado del Periodo',
					totalResult: total.totalResult + (acum.balance || 0),
				}),
				{
					title: 'Resultado del Periodo',
					totalResult: 0,
				},
			);
		} else if (
			this.report.code === 'result-status' &&
			this.selectedTypeBalance === 2
		) {
			this.deleteParams();
			this.params.account = '4';
			this.params.level = this.levelId;
			this.params.subsidiaryId = this.subsidiary.id;
			delete this.params.costCenterId;
			delete this.params.limit;
			delete this.params.page;
			const body = this.report.code === 'result-status' && this.selectedTypeBalance === 2
				? { code: 'monthly-cumulative-income-statement' }
				: null;
			const response = await this.$http.post('grouped-balance-sheet', body, {
				params: this.params,
			});
			this.periodData = response.data;
			this.flagMonthBalance = true;
		}
	} catch (error) {
		// Deja el error real en consola para poder rastrearlo.
		// eslint-disable-next-line no-console
		console.error('[general-reports] loadData', this.report && this.report.code, error);
		const message = error && error.data && error.data.message;
		this.showGenericError(message
			? `No se pudo generar el reporte: ${message}`
			: 'No se pudo generar el reporte. Revise la consola para más detalle.');
	}
}
async function downloadReportExcel(month = false) {
	try {
		this.isLoading = true;
		let urlService = '';
		const params = {
			startDate: this.params.startDate,
			endDate: this.params.endDate,
			subsidiaryId: this.subsidiary ? this.subsidiary.id : undefined,
		};
		if (this.report.code === 'major-general') {
			params.startAccount = this.startAccount
				? this.startAccount.account
				: null;
			params.endAccount = this.endAccount ? this.endAccount.account : null;
		}
		if (this.report.code === 'balance-sheet') {
			params.account = '3';
			params.level = this.levelId;
			params.costCenterId = this.costCenterId;
		}
		if (this.report.code === 'accounting-book') {
			params.status = '1';
			params.typeRegisterId = this.typeRegisterId;
		}
		if (this.report.code === 'result-status') {
			params.account = '4';
			params.level = this.levelId;
			params.costCenterId = this.costCenterId;
		}
		if (month && this.report.code === 'result-status') {
			params.flagPdf = true;
		}
		const body = {
			code: this.report.code,
		};
		urlService = 'reports-excel';
		const { data: blobData } = await this.$http.post(urlService, body, {
			params,
		});
		const byteCharacters = atob(blobData.base64);
		const byteNumbers = [];
		byteCharacters.split('').forEach((char) => {
			byteNumbers.push(char.charCodeAt(0));
		});

		const byteArray = new Uint8Array(byteNumbers);
		const buffer = byteArray.buffer;

		// Crear un Blob a partir del ArrayBuffer
		const blob = new Blob([buffer], { type: 'application/octet-stream' });

		// Crear un objeto URL para descargar el archivo
		const url = URL.createObjectURL(blob);

		// Crear un enlace (link) para la descarga
		const link = document.createElement('a');
		link.href = url;
		let nameReport = '';
		if (this.params.startDate) {
			nameReport = `${this.report.fileName}${this.params.startDate}${this.params.endDate}.xlsx`;
		} else {
			nameReport = `${this.report.fileName}${this.params.endDate}.xlsx`;
		}
		link.download = nameReport; // Cambia el nombre del archivo según desees

		// Simular un clic para iniciar la descarga
		link.click();

		// Revocar el objeto URL para liberar recursos del navegador
		URL.revokeObjectURL(url);
	} catch (error) {
		if (error.status === 400) {
			this.showNotification(
				'Su compañía no cuenta con este reporte',
				'warning',
			);
		} else {
			this.showGenericError();
		}
	} finally {
		this.isLoading = false;
	}
}

async function downloadReport(type) {
	try {
		this.isLoading = true;
		this.params.subsidiaryId = this.subsidiary ? this.subsidiary.id : undefined;
		if (this.report.code === 'balance-sheet') {
			this.params.startDate = null;
		}
		if (type === 'preview') {
			this.loadData();
			if (!this.validateComponenteTable) {
				this.showComponentTable = true;
				this.showComponentPdf = true;
			} else {
				this.showComponentTable = true;
				this.showComponentPdf = false;
			}
			this.showMssg = !this.validateComponenteTable && true;
		} else if (type === 'download') {
			const params = {
				responseType: 'blob',
				params: {
					startDate: this.params.startDate,
					endDate: this.params.endDate,
					subsidiaryId: this.subsidiary ? this.subsidiary.id : undefined,
				},
			};
			const { post } = this.report;
			let newPost = {};
			if (this.report.code === 'result-status' &&
				this.selectedTypeBalance === 2) {
				this.$set(newPost, 'code', 'monthly-cumulative-income-statement');
			} else {
				newPost = post;
			}
			let url = '';
			if (this.report.code === 'accounting-book') {
				params.params.status = '1';
				params.params.typeRegisterId = this.typeRegisterId || null;
				url = 'accounting-seats/pdf';
			} else if (this.report.code === 'checking-balance') {
				url = 'trial-balance/pdf';
			} else if (this.report.code === 'balance-sheet') {
				params.params.account = '3';
				params.params.level = this.levelId;
				params.params.costCenterId = this.costCenterId;
				url = 'accounting-seat-report/pdf';
			} else if (this.report.code === 'major-general') {
				params.params.startAccount = this.startAccount
					? this.startAccount.account
					: null;
				params.params.endAccount = this.endAccount
					? this.endAccount.account
					: null;
				url = 'major-general/pdf';
			} else if (this.report.code === 'result-status' &&
				this.selectedTypeBalance === 2) {
				params.params.account = '4';
				params.params.level = this.levelId;
				params.params.costCenterId = this.costCenterId;
				url = 'grouped-balance-sheet';
				params.params.flagPdf = true;
			} else if (this.report.code === 'result-status' &&
				this.selectedTypeBalance === 1) {
				params.params.account = '4';
				params.params.level = this.levelId;
				params.params.costCenterId = this.costCenterId;
				url = 'accounting-seat-report/pdf';
			}
			const { data: blobData } = await this.$http.post(url, newPost, params);
			const blob = helper.generateBlob(blobData);
			const urlObject = URL.createObjectURL(blob);
			const iFrame = document.createElement('iframe');
			iFrame.setAttribute('src', urlObject);
			iFrame.setAttribute('style', 'height:100vh;width:100%');
			const childNodes = this.$refs.viewer.childNodes;
			if (childNodes.length > 0) {
				this.$refs.viewer.removeChild(this.$refs.viewer.childNodes[0]);
			}
			this.$refs.viewer.append(iFrame);
			this.showMssg = !this.validateComponenteTable && false;
			if (!this.validateComponenteTable) {
				this.showComponentTable = true;
				this.showComponentPdf = true;
			} else {
				this.showComponentTable = false;
				this.showComponentPdf = true;
			}
		}
	} catch (error) {
		if (error.status === 400) {
			this.showNotification(
				'Su compañía no cuenta con este reporte',
				'warning',
			);
		} else {
			this.showGenericError();
		}
	} finally {
		this.isLoading = false;
	}
}

function closeModal() {
	this.action.value = false;
	this.action.code = '';
	delete this.accountingParams.search;
}

function changeSelect(code, select) {
	this.params.page = 1;
	if (select.code === 'balance-sheet') {
		this.getDataDate(6);
	} else {
		this.getDataDate(4);
	}
	this[code] = select;
	if (select.code === 'major-general') {
		this.startAccount.fullName = null;
		this.endAccount.fullName = null;
		this.loadAccounts();
	} else {
		this.startAccount.fullName = null;
		this.endAccount.fullName = null;
		this.params.typeRegisterId = null;
		this.params.status = null;
	}
	this.cleanFilter();
}
function changeSelectLevel(code, select) {
	this.params.page = 1;
	this[code] = select;
	if (select.code === 'major-general') {
		this.startAccount.fullName = null;
		this.endAccount.fullName = null;
		this.loadAccounts();
	} else {
		this.startAccount.fullName = null;
		this.endAccount.fullName = null;
		this.params.typeRegisterId = null;
		this.params.status = null;
	}
}

async function changeSelectTipe(select) {
	if (select === 2) {
		this.selectedTypeBalance = select;
	} else {
		this.selectedTypeBalance = select;
	}
}

function changetypeResult(code, select) {
	this.params.page = 1;
	this[code] = select;
	if (select.code === 'major-general') {
		this.startAccount.fullName = null;
		this.endAccount.fullName = null;
		this.loadAccounts();
	} else {
		this.startAccount.fullName = null;
		this.endAccount.fullName = null;
		this.params.typeRegisterId = null;
		this.params.status = null;
	}
}

function getCenterCost(value) {
	this.costCenterId = value.id;
}

function valuesDisabled() {
	if (this.report.code !== 'major-general') {
		return [
			{ code: 'general-account-initial', disabled: true },
			{ code: 'general-account-final', disabled: true },
		];
	}
	return [];
}

function runAction({ codeWeb }) {
	if (codeWeb === 'general-account-initial') {
		this.openSearcher();
	} else if (codeWeb === 'general-account-final') {
		this.openSearcherFinally();
	}
}
function getOpenSearcher() {
	this.openSearcher();
}
function getOpenSearcherFinally() {
	this.openSearcherFinally();
}

function changeModule(code, select) {
	this.params.page = 1;
	this.typeRegisterId = select.id;
}

function currentSubsidiary(newValue) {
	this.subsidiary = newValue;
}
function closeDialog() {
	this.nameAccouting = null;
	this.dialogDetailAccountingMajor = false;
}

async function loadCostCenter() {
	try {
		const response = await this.$http.get(
			`cost-center/${this.currentSubsidiary.id}/subsidiary`,
		);
		this.costcenters = response.data;
	} catch (error) {
		this.costcenters = [];
		this.showNotification('Seleccione una empresa.', 'warning');
	}
}

function openSearcher() {
	this.paramsRecords.search = null;
	if (this.newSubsidiaryId) {
		this.loadAccounts();
	}
	this.action.title = 'Buscar Cuenta Contable';
	this.action.code = 'searcher';
	this.action.width = 550;
	this.action.value = true;
}

function openSearcherFinally() {
	this.paramsRecords.search = null;
	this.loadAccounts();
	this.action.title = 'Buscar Cuenta Contable';
	this.action.code = 'searcherFinally';
	this.action.width = 550;
	this.action.value = true;
}

function isActionCode(code) {
	return this.action.code === code;
}

function verifySubsidiary() {
	if (Object.entries(this.subsidiary).length !== 0) {
		return true;
	}
	return false;
}

function changePageAccount(page) {
	this.loadAccounts(page);
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
	this.loadData();
}

function onSearch(searchValue) {
	const searchTrim = searchValue ? searchValue.trim() : null;
	this.params.search = searchTrim;
	this.loadData();
}

function nameInputDate() {
	return this.report.code === 'balance-sheet'
		? 'Fecha límite para reporte'
		: 'Fecha Hasta';
}

function report(newVal, oldVal) {
	if (newVal !== oldVal) {
		const childNodes = this.$refs.viewer.childNodes;
		if (childNodes.length > 0) {
			this.$refs.viewer.removeChild(this.$refs.viewer.childNodes[0]);
		}
	}
}

function formatData(value) {
	if (value === null || value === undefined) return '';
	if (typeof value !== 'string') {
		const number = parseFloat(value);
		return (Number.isNaN(number) ? 0 : number).toLocaleString('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	}
	return value;
}

function validateComponenteTable() {
	return (
		this.report &&
		(this.report.code === 'balance-sheet' ||
			this.report.code === 'checking-balance' ||
			this.report.code === 'result-status')
	);
}

function data() {
	return {
		endDate: this.$today,
		isLoading: false,
		promesaExcelMayor: null,
		account: {},
		searchMajor: '',
		filterMajor: 'todos',
		periodData: [],
		lastPageSearcher: 0,
		accountFinally: {},
		paramsRecords: {
			search: null,
			limit: 30,
			page: 1,
		},
		code: '',
		reports: [
			{
				id: 1,
				fileName: 'libro-diario',
				name: 'Libro Diario',
				code: 'accounting-book',
				post: {
					code: 'accounting-book',
				},
			},
			{
				id: 2,
				fileName: 'balance-general',
				name: 'Balance General',
				code: 'balance-sheet',
				post: {
					code: 'balance-sheet',
				},
			},
			{
				id: 3,
				fileName: 'balance-comprobacion',
				name: 'Balance de comprobación',
				code: 'checking-balance',
				post: {
					code: 'checking-balance',
				},
			},
			{
				id: 4,
				fileName: 'mayor-general',
				name: 'Mayor General',
				code: 'major-general',
				post: {
					code: 'major-general',
				},
			},
			{
				id: 5,
				fileName: 'estado-resultados',
				name: 'Estado de resultados',
				code: 'result-status',
				post: {
					code: 'result-status',
				},
			},
		],
		columnsAccount: [
			{
				id: 1,
				name: 'Nombre',
				value: 'name',
				checked: true,
				visible: true,
			},
			{
				id: 2,
				name: 'Cuenta',
				value: 'account',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'Acción',
				checked: true,
				visible: true,
				flagVisible: true,
			},
		],
		levels: [
			{ id: 1, level: 'Nivel 1' },
			{ id: 2, level: 'Nivel 2' },
			{ id: 3, level: 'Nivel 3' },
			{ id: 4, level: 'Nivel 4' },
			{ id: 5, level: 'Nivel 5' },
			{ id: 6, level: 'Nivel 6' },
			{ id: 7, level: 'Nivel 7' },
			{ id: 8, level: 'Nivel 8' },
			{ id: 9, level: 'Nivel 9' },
		],
		typesReport: [
			{ id: 1, level: 'General' },
			{ id: 2, level: 'Mensual' },
		],
		typesDate: [
			{ id: 1, name: 'Hoy' },
			{ id: 2, name: 'Ayer' },
			{ id: 3, name: 'Ultima Semana' },
			{ id: 4, name: 'Mes Actual' },
			{ id: 5, name: 'Año Actual' },
			{ id: 6, name: 'Rangos de Fechas' },
		],
		typeDateId: null,
		report: null,
		startDate: null,
		selectedReport: null,
		levelId: null,
		costCenterId: null,
		flagMonthBalance: false,
		selectedTypeBalance: 1,
		costcenters: [],
		subsidiary: {},
		results: [],
		resultsChecking: [],
		totalResultChecking: {},
		totalIncomeStatement: {},
		totalBalance: {},
		resultss: [],
		columnsBalance: [
			{
				id: 1,
				name: 'Código de Cuenta',
				value: 'account',
				icon: true,
				class: 'xs4',
			},
			{
				id: 2,
				name: 'Nombre de Cuenta',
				value: 'name',
				icon: false,
				class: 'xs7',
			},
			{
				id: 3,
				name: 'Saldos',
				value: 'balance',
				icon: false,
				class: 'xs1 text-xs-rigth',
			},
		],
		columnsTotalBalance: [
			{ id: 1, name: 'title', class: 'xs11' },
			{ id: 2, name: 'totalResult', class: 'xs1 text-xs-rigth pr-3' },
		],
		headers: [
			{ text: 'Fecha', value: 'date', align: 'left', sortable: false },
			{ text: 'Asiento', value: 'seat', align: 'left', sortable: false },
			{ text: 'Referencia', value: 'reference', align: 'left', sortable: false },
			{ text: 'Débito', value: 'debit', align: 'right', sortable: false },
			{ text: 'Crédito', value: 'credit', align: 'right', sortable: false },
			{ text: 'Saldo', value: 'balance', align: 'right', sortable: false },
		],
		pagination: {
			sortBy: '',
			descending: false,
			rowsPerPage: -1, // muestra todas las filas
		},
		columnsCheckingBalance: [
			{
				id: 1,
				name: 'Código de Cuenta',
				value: 'account',
				icon: true,
				class: 'xs2',
			},
			{
				id: 2,
				name: 'Nombre de Cuenta',
				value: 'name',
				icon: false,
				class: 'xs5',
			},
			{
				id: 3,
				name: 'Saldo Anterior',
				value: 'previousBalance',
				icon: false,
				class: 'xs1 text-xs-right pr-1',
			},
			{
				id: 4,
				name: 'Debe',
				value: 'debit',
				icon: false,
				class: 'xs1 text-xs-right pr-1',
			},
			{
				id: 5,
				name: 'Haber',
				value: 'credit',
				icon: false,
				class: 'xs1 text-xs-right pr-1',
			},
			{
				id: 6,
				name: 'Saldo Deudor',
				value: 'debitBalance',
				icon: false,
				class: 'xs1 text-xs-right pr-1',
			},
			{
				id: 7,
				name: 'Saldo Acreedor',
				value: 'creditBalance',
				icon: false,
				class: 'xs1 text-xs-right pr-1',
			},
		],
		columnsTotalCheckingBalance: [
			{ id: 1, name: 'title', class: 'xs7' },
			{ id: 2, name: 'totalPreviousBalance', class: 'xs1 text-xs-right pr-1' },
			{ id: 3, name: 'totalDebit', class: 'xs1 text-xs-right pr-1' },
			{ id: 4, name: 'totalCredit', class: 'xs1 text-xs-right pr-1' },
			{ id: 5, name: 'totalDebitBalance', class: 'xs1 text-xs-right pr-1' },
			{ id: 6, name: 'totalCreditBalance', class: 'xs1 text-xs-right pr-1' },
		],
		columnsAccountingBook: [
			{
				id: 1,
				name: 'Fecha',
				value: 'date',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: '# Asiento',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Descripión',
				value: 'gloss',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Detalle',
				value: 'details',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		columnsMajorGeneral: [
			{
				id: 1,
				name: 'Código de Cuenta',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Descripcion de la cuenta',
				value: 'description',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Detalle',
				value: 'details',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		columnsIncomeStatement: [
			{
				id: 1,
				name: 'Codigo de Cuenta',
				value: 'account',
				icon: true,
				class: 'xs4',
			},
			{
				id: 2,
				name: 'Nombre de Cuenta',
				value: 'name',
				icon: false,
				class: 'xs7',
			},
			{
				id: 3,
				name: 'Saldo',
				value: 'balance',
				icon: false,
				class: 'xs1 text-xs-right pr-3',
			},
		],
		columnsTotalIncomeStatement: [
			{ id: 1, name: 'title', class: 'xs11' },
			{ id: 2, name: 'totalResult', class: 'xs1 text-xs-right pr-3' },
		],
		columnsDetail: [
			{
				id: 1,
				name: 'Código',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Nombre',
				value: 'name',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Referencia',
				value: 'reference',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Debe',
				value: 'debit',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 5,
				name: 'Haber',
				value: 'credit',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		columnsDetailMajo: [
			{
				id: 1,
				name: 'Fecha',
				value: 'date',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Asiento',
				value: 'seat',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Descripción',
				value: 'description',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Debe',
				value: 'debit',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 5,
				name: 'Haber',
				value: 'credit',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 6,
				name: 'Saldo',
				value: 'balance',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		typeCode: '',
		lastPage: null,
		flagDate: false,
		totalItems: 0,
		nameAccouting: null,
		action: {
			code: '',
			title: 'Buscar Cuenta Contable',
			value: false,
			width: 500,
		},
		modules: [],
		rowsDetailModal: [],
		rowsDetailModalMajor: [],
		mobile: false,
		currentPage: 1,
		typeRegisterId: null,
		majorGeneralDescription: null,
		previousBalance: null,
		previousDate: null,
		balanceMajor: null,
		majorGeneralCode: null,
		dialogDetailAccounting: false,
		dialogDetailAccountingMajor: false,
		accounts: [],
		params: {
			startDate: null,
			endDate: null,
			subsidiaryId: null,
			limit: 10,
			page: 1,
		},
		startAccount: {
			fullName: null,
		},
		endAccount: {
			fullName: '',
		},
		showComponentTable: false,
		showComponentPdf: false,
		showMssg: true,
	};
}
export default {
	name: 'general-reports',
	data,
	created,
	components: {
		BaseInput: () => import('@/components/shared/inputs/base-input'),
		appDateSelect,
		actionBar,
		accountingSearcher,
		dateComponent,
		actionSidebar,
		headerPage,
		generalFilter,
		BaseSelect,
		appTable,
		tableMayor,
		appTooltipButton,
		accountantTableTree,
		balanceSheetMonth,
		slideSearcher,
	},
	computed: {
		valuesDisabled,
		// filas tal como llegan, sin filtrar
		rowsMajorBase() {
			return this.rowsDetailModalMajor || [];
		},
		totalRowsMajor() {
			return this.rowsMajorBase.length;
		},
		// la columna Descripción solo aparece si las filas traen ese dato
		hayDescripcionMajor() {
			return this.rowsMajorBase.some(item => !!this.descripcionMajor(item));
		},
		claseGridMajor() {
			return this.hayDescripcionMajor ? 'mayor-grid' : 'mayor-grid mayor-grid--sin-desc';
		},
		rowsMajorFiltradas() {
			const texto = `${this.searchMajor || ''}`.trim().toLowerCase();
			return this.rowsMajorBase.filter((item) => {
				const debito = Number(item.debit) || 0;
				const credito = Number(item.credit) || 0;
				if (this.filterMajor === 'debitos' && debito === 0) {
					return false;
				}
				if (this.filterMajor === 'creditos' && credito === 0) {
					return false;
				}
				if (!texto) {
					return true;
				}
				const campos = [
					item.seat,
					item.reference,
					this.descripcionMajor(item),
				].join(' ').toLowerCase();
				return campos.indexOf(texto) > -1;
			});
		},
		saldoInicialMajor() {
			return Number(this.previousBalance) || 0;
		},
		// las sumas y el saldo final describen el PERIODO completo:
		// no cambian aunque filtres o busques, solo cambia lo que se ve en la tabla
		sumaDebitosMajor() {
			const suma = this.rowsMajorBase
				.reduce((total, item) => total + (Number(item.debit) || 0), 0);
			return Math.round(suma * 100) / 100;
		},
		sumaCreditosMajor() {
			const suma = this.rowsMajorBase
				.reduce((total, item) => total + (Number(item.credit) || 0), 0);
			return Math.round(suma * 100) / 100;
		},
		saldoFinalMajor() {
			const suma = (this.saldoInicialMajor + this.sumaDebitosMajor) - this.sumaCreditosMajor;
			return Math.round(suma * 100) / 100;
		},
		...mapGetters('subsidiary', ['currentSubsidiary']),
		verifySubsidiary,
		nameInputDate,
		validateComponenteTable,
	},
	methods: {
		descripcionMajor(item) {
			if (!item) {
				return '';
			}
			return item.description || item.gloss || item.concept || '';
		},
		claseMonto(valor) {
			return (Number(valor) || 0) < 0 ? 'mayor-negativo' : 'mayor-positivo';
		},
		cargarExcelJS() {
			if (window.ExcelJS) {
				return Promise.resolve(window.ExcelJS);
			}
			if (!this.promesaExcelMayor) {
				this.promesaExcelMayor = new Promise((resolve, reject) => {
					const script = document.createElement('script');
					script.src = '/static/js/exceljs.min.js';
					script.onload = () => resolve(window.ExcelJS);
					script.onerror = () => {
						this.promesaExcelMayor = null;
						reject(new Error('No se pudo cargar exceljs.min.js'));
					};
					document.head.appendChild(script);
				});
			}
			return this.promesaExcelMayor;
		},
		// usa el filtro exactDate que ya tienes registrado; si no existe, deja la fecha cruda
		fechaMayor(valor) {
			const filtros = this.$options.filters || {};
			if (filtros.exactDate) {
				return filtros.exactDate(valor);
			}
			return valor || '';
		},
		filasExportMayor() {
			const filas = [{
				date: this.previousDate,
				seat: 'SALDO INICIAL',
				reference: '-',
				description: `Saldo inicial al ${this.previousDate}`,
				debit: 0,
				credit: 0,
				balance: this.saldoInicialMajor,
			}];
			this.rowsMajorFiltradas.forEach((item) => {
				filas.push({
					date: this.fechaMayor(item.date),
					seat: item.seat || '',
					reference: item.reference || '',
					description: this.descripcionMajor(item),
					debit: Number(item.debit) || 0,
					credit: Number(item.credit) || 0,
					balance: Number(item.balance) || 0,
				});
			});
			return filas;
		},
		construirLibroMayor(Excel) {
			const libro = new Excel.Workbook();
			const hoja = libro.addWorksheet('Mayor General');
			const conDescripcion = this.hayDescripcionMajor;
			const columnas = [
				{ header: 'Fecha', key: 'date', width: 14 },
				{ header: 'Asiento', key: 'seat', width: 24 },
				{ header: 'Referencia', key: 'reference', width: 26 },
			];
			if (conDescripcion) {
				columnas.push({ header: 'Descripción', key: 'description', width: 44 });
			}
			columnas.push({ header: 'Débito', key: 'debit', width: 15 });
			columnas.push({ header: 'Crédito', key: 'credit', width: 15 });
			columnas.push({ header: 'Saldo corriente', key: 'balance', width: 18 });
			hoja.columns = columnas;
			const ultimaLetra = conDescripcion ? 'G' : 'F';
			const cuenta = `${this.majorGeneralCode} ${this.majorGeneralDescription}`;
			const titulo = `Mayor General · ${cuenta}`;
			hoja.spliceRows(1, 0, [titulo]);
			hoja.spliceRows(2, 0, [`Saldo al ${this.previousDate}`]);
			hoja.mergeCells(`A1:${ultimaLetra}1`);
			hoja.mergeCells(`A2:${ultimaLetra}2`);
			hoja.getRow(1).height = 24;
			hoja.getCell('A1').font = { bold: true, size: 13, color: { argb: 'FF16222B' } };
			hoja.getCell('A2').font = { size: 10, color: { argb: 'FF66727E' } };
			const cabecera = hoja.getRow(3);
			cabecera.height = 20;
			cabecera.eachCell((celda) => {
				const nueva = celda;
				nueva.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
				nueva.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'FF0E6B63' },
				};
				nueva.alignment = { horizontal: 'center', vertical: 'middle' };
			});
			this.filasExportMayor().forEach((fila) => {
				hoja.addRow(fila);
			});
			const primera = 4;
			const ultima = hoja.rowCount;
			const filaTotal = hoja.addRow({
				seat: 'TOTAL',
				debit: this.sumaDebitosMajor,
				credit: this.sumaCreditosMajor,
				balance: this.saldoFinalMajor,
			});
			filaTotal.eachCell((celda) => {
				const nueva = celda;
				nueva.font = { bold: true };
				nueva.border = { top: { style: 'thin', color: { argb: 'FFB9C6CC' } } };
			});
			const columnasNumero = conDescripcion ? ['E', 'F', 'G'] : ['D', 'E', 'F'];
			for (let fila = primera; fila <= hoja.rowCount; fila += 1) {
				columnasNumero.forEach((columna) => {
					hoja.getCell(`${columna}${fila}`).numFmt = '#,##0.00';
				});
			}
			hoja.views = [{ state: 'frozen', ySplit: 3 }];
			hoja.autoFilter = { from: 'A3', to: `${ultimaLetra}${ultima}` };
			return libro;
		},
		async exportarMayor() {
			if (this.rowsMajorFiltradas.length === 0) {
				return;
			}
			const Excel = await this.cargarExcelJS();
			const libro = this.construirLibroMayor(Excel);
			const buffer = await libro.xlsx.writeBuffer();
			const blob = new Blob([buffer], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			});
			const url = URL.createObjectURL(blob);
			const enlace = document.createElement('a');
			enlace.href = url;
			enlace.download = `mayor-general-${this.majorGeneralCode || 'cuenta'}.xlsx`;
			document.body.appendChild(enlace);
			enlace.click();
			document.body.removeChild(enlace);
			URL.revokeObjectURL(url);
		},
		escaparHtml(valor) {
			return `${valor === null || valor === undefined ? '' : valor}`
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;');
		},
		montoImpresion(valor) {
			const numero = Number(valor) || 0;
			const texto = numero.toLocaleString('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
			return numero < 0 ? `<span class="neg">${texto}</span>` : texto;
		},
		htmlImpresionMayor() {
			const conDescripcion = this.hayDescripcionMajor;
			const cabeceras = ['Fecha', 'Asiento', 'Referencia'];
			if (conDescripcion) {
				cabeceras.push('Descripción');
			}
			cabeceras.push('Débito', 'Crédito', 'Saldo corriente');
			const totalColumnas = cabeceras.length;
			const encabezado = cabeceras.map((titulo, i) => {
				const clase = i >= totalColumnas - 3 ? ' class="num"' : '';
				return `<th${clase}>${titulo}</th>`;
			}).join('');
			const cuerpo = this.filasExportMayor().map((fila) => {
				const celdas = [
					`<td>${this.escaparHtml(fila.date)}</td>`,
					`<td>${this.escaparHtml(fila.seat)}</td>`,
					`<td>${this.escaparHtml(fila.reference)}</td>`,
				];
				if (conDescripcion) {
					celdas.push(`<td>${this.escaparHtml(fila.description)}</td>`);
				}
				celdas.push(`<td class="num">${this.montoImpresion(fila.debit)}</td>`);
				celdas.push(`<td class="num">${this.montoImpresion(fila.credit)}</td>`);
				celdas.push(`<td class="num bold">${this.montoImpresion(fila.balance)}</td>`);
				return `<tr>${celdas.join('')}</tr>`;
			}).join('');
			const vacias = conDescripcion ? 4 : 3;
			const codigo = this.escaparHtml(this.majorGeneralCode);
			const cuenta = this.escaparHtml(this.majorGeneralDescription);
			const fecha = this.escaparHtml(this.previousDate);
			const pie = `<tr class="total"><td colspan="${vacias}">TOTAL</td>`
				+ `<td class="num">${this.montoImpresion(this.sumaDebitosMajor)}</td>`
				+ `<td class="num">${this.montoImpresion(this.sumaCreditosMajor)}</td>`
				+ `<td class="num bold">${this.montoImpresion(this.saldoFinalMajor)}</td></tr>`;
			return `<!DOCTYPE html><html lang="es"><head><meta charset="utf-8">
				<title>Mayor General ${codigo}</title>
				<style>
					* { box-sizing: border-box; }
					body { font-family: Arial, Helvetica, sans-serif; color: #16222b; margin: 18px; }
					h1 { font-size: 17px; margin: 0; }
					.sub { color: #66727e; font-size: 11px; margin: 3px 0 14px; }
					table { border-collapse: collapse; width: 100%; font-size: 11px; }
					th { background: #0e6b63; color: #fff; font-size: 10px; letter-spacing: .4px;
						padding: 7px 8px; text-align: left; text-transform: uppercase; }
					td { border-bottom: 1px solid #e6ebee; padding: 6px 8px; }
					.num { text-align: right; white-space: nowrap; }
					.bold { font-weight: bold; }
					.neg { color: #c62828; }
					.total td { border-top: 2px solid #b9c6cc; font-weight: bold; }
					@media print {
						body { margin: 0; }
						thead { display: table-header-group; }
						tr { page-break-inside: avoid; }
					}
				</style></head><body>
				<h1>Mayor General · ${codigo} ${cuenta}</h1>
				<div class="sub">Saldo al ${fecha}</div>
				<table><thead><tr>${encabezado}</tr></thead><tbody>${cuerpo}${pie}</tbody></table>
				</body></html>`;
		},
		imprimirMayor() {
			const ventana = window.open('', '_blank', 'width=1100,height=760');
			if (!ventana) {
				return;
			}
			ventana.document.open();
			ventana.document.write(this.htmlImpresionMayor());
			ventana.document.close();
			ventana.focus();
			setTimeout(() => {
				ventana.print();
				ventana.close();
			}, 400);
		},
		changeSelect,
		cleanFilter,
		getCenterCost,
		changeSelectLevel,
		changetypeResult,
		changeSelectTipe,
		downloadReport,
		downloadReportExcel,
		closeModal,
		loadCostCenter,
		openSearcher,
		runAction,
		getDataDate,
		onSearchRecords,
		addRecord,
		addRecordFinally,
		isActionCode,
		setDate,
		changePage,
		changePageAccount,
		openSearcherFinally,
		changeModule,
		getOpenSearcherFinally,
		getOpenSearcher,
		onSearch,
		loadData,
		loadModules,
		openDetailMajor,
		deleteParams,
		openDetail,
		closeDialog,
		loadAccounts,
		formatData,
	},
	watch: {
		currentSubsidiary,
		report,
	},
};
</script>
<style lang="scss" scoped>
[data-tooltip] {
	position: relative;
	cursor: pointer;
}

[data-tooltip]:hover::before {
	content: attr(data-tooltip);
	position: absolute;
	top: -25px;
	/* Cambia el valor para ajustar la posición hacia arriba */
	left: 50%;
	transform: translateX(-50%);
	background-color: #1fd9b6;
	/* Cambia el valor para ajustar la transparencia (0 a 1) */
	color: #fff;
	padding: 4px 8px;
	border-radius: 4px;
	white-space: nowrap;
	z-index: 999;
	font-size: 11px;
	/* Ajusta el tamaño del texto según tus preferencias */
	font-family: 'Avenir Regular', sans-serif;
	/* Establece la fuente deseada */
}

.theme--light {
	color: #fff !important;
}

.filter-select.v-input {
	background: white;
	border: 1px solid #a9bac2;
	border-radius: 5px;
	height: 33px;
	padding: 0px;
}

.reference {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/5;
		grid-row: 2;
		white-space: nowrap;
	}
}

.referenceMajor {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/7;
		grid-row: 2;
		white-space: nowrap;
	}
}

.debit {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/4;
		grid-row: 2;
		white-space: nowrap;
	}
}

.credit {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/4;
		grid-row: 3;
		white-space: nowrap;
	}
}

.credit-balance {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/4;
		grid-row: 4;
		white-space: nowrap;
	}
}

.debit-balance {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/4;
		grid-row: 5;
		white-space: nowrap;
	}
}

.gloss {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/4;
		grid-row: 2;
		white-space: nowrap;
	}
}

.captionDate {
	font-size: 10px;
	text-align: center;
	font-family: 'AvenirRegular';
}

.v-dialog-title {
	font-size: 12px;
	/* Tamaño de fuente */
	font-weight: bold;
	/* Peso de fuente */
	color: black !important;
	/* Color del título */
	text-transform: uppercase;
	/* Transformación de texto a mayúsculas */
	letter-spacing: 2px;
	/* Espaciado entre letras */
	font-family: 'Avenir Regular', sans-serif;
	height: auto !important;
	line-height: 30px;
	margin: 10px;
	align-content: -end;
}

.v-dialog-footer {
	font-size: 12px;
	/* Tamaño de fuente */
	font-weight: bold;
	/* Peso de fuente */
	color: black !important;
	/* Color del título */
	text-transform: uppercase;
	/* Transformación de texto a mayúsculas */
	letter-spacing: 2px;
	/* Espaciado entre letras */
	font-family: 'Avenir Regular', sans-serif;
	height: 50px !important;
}

.custom-btn {
	/* Estilo para hacer el botón de cerrar elegante */
	color: #f44336;
	/* Color del icono (rojo) */
	background-color: #ffffff;
	/* Color de fondo (blanco) */
}

/* Estilos para el hover y focus del botón */
.custom-btn:hover {
	background-color: #f44336;
	/* Color de fondo rojo más oscuro */
	color: #ffffff;
}

.custom-btn:focus {
	background-color: #f44336;
	/* Color de fondo rojo más oscuro */
	color: #ffffff;
	/* Color del icono (blanco) */
}

.content-label {
	color: #2c404a;
	background-color: #e0e5e8;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 10px;
	font-weight: 500;
	width: 70px;
	height: 27px;
}

.content-label-total {
	color: #2c404a;
	background-color: #e0e5e8;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 10px;
	font-weight: 500;
	width: auto;
	height: 27px;
}

.content-text {
	background-color: white;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 16px;
}

.content-text-title {
	background-color: white;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 24px;
}

.mobile {
	@media (max-width: 768px) {
		display: none;
	}
}

.desktop {
	@media (min-width: 768px) {
		display: none;
	}
}

.total-table {
	color: #2c404a;
	font-family: font(open-regular);
	font-size: size(small11);
}
.total-row {
	border: 1px solid #e0e5e8;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: end;
}
.title-table {
	background-color: #02979b;
	border: 1px solid #02979b;
	text-transform: uppercase;
	color: #eceff1;
	font-weight: bold;
	font-family: font(open-regular);
	font-size: size(small);
	text-align: center;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: end;
	padding-right: 10px;
}
.btn-report {
	font-weight: bold !important;
	padding: 0 auto;
	display: flex;
	flex-direction: column;
	text-align: center;
	font-size: 10px !important;
	border-radius: 10px;
	.v-icon {
		padding-right: 10px;
	}
	img {
		padding-right: 10px;
	}
}
@media (max-width: 1200px) {
	.btn-report {
		font-size: 8.5px !important;
		.v-icon {
			padding-right: 5px;
		}
		img {
			padding-right: 5px;
		}
	}
}

.container-mssg {
	border: 3px solid PowderBlue;
	border-radius: 10px;
	display: flex;
	padding: 0 auto;
	p {
		color: color(action-disabled);
		margin: 0 auto;
		padding: 20px 0;
		text-align: center;
		font-weight: bold;
	}
}
/// tabla moderna
/* =====================================================
   CONTENEDOR PRINCIPAL
===================================================== */
/* =====================================================
   MAYOR GENERAL · modal
===================================================== */

.mayor-dialog {
	background: #ffffff;
	border-radius: 14px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	width: 100%;
}

/* ---------------- cabecera ---------------- */

.mayor-header {
	align-items: center;
	background: linear-gradient(90deg, #0e6b63 0%, #0a5a55 100%);
	color: #ffffff;
	display: flex;
	justify-content: space-between;
	padding: 18px 28px;
}

.mayor-title {
	font-size: 26px;
	font-weight: 700;
	line-height: 1.1;
}

.mayor-subtitle {
	font-size: 12.5px;
	margin-top: 4px;
	opacity: 0.75;
}

.mayor-close {
	background: transparent;
	border: none;
	color: #ffffff;
	cursor: pointer;
	font-size: 26px;
	height: 32px;
	line-height: 1;
	opacity: 0.85;
	outline: none;
	width: 32px;
}

.mayor-close:hover {
	opacity: 1;
}

/* ---------------- cuenta + tarjetas ---------------- */

.mayor-resumen {
	align-items: center;
	border-bottom: 1px solid #e6ebee;
	display: flex;
	gap: 24px;
	justify-content: space-between;
	padding: 18px 28px;
}

.mayor-cuenta {
	align-items: flex-start;
	display: flex;
	gap: 14px;
	min-width: 0;
}

.mayor-cuenta__icono {
	align-items: center;
	background: #0e6b63;
	border-radius: 10px;
	color: #ffffff;
	display: flex;
	flex: 0 0 52px;
	height: 52px;
	justify-content: center;
	width: 52px;
}

.mayor-cuenta__datos {
	display: grid;
	gap: 2px 14px;
	grid-template-columns: auto minmax(0, 1fr);
	min-width: 0;
}

.mayor-etiqueta {
	color: #8a97a1;
	font-size: 10.5px;
	font-weight: 700;
	letter-spacing: 0.7px;
	text-transform: uppercase;
	white-space: nowrap;
}

.mayor-cuenta__codigo {
	color: #0e6b63;
	font-size: 13.5px;
	font-weight: 700;
}

.mayor-cuenta__nombre {
	color: #16222b;
	font-size: 14px;
	font-weight: 700;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mayor-cuenta__detalle {
	color: #66727e;
	font-size: 12.5px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mayor-kpis {
	display: grid;
	flex: 0 0 auto;
	gap: 12px;
	grid-template-columns: repeat(4, minmax(140px, 1fr));
}

.mayor-kpi {
	background: #ffffff;
	border: 1px solid #e3e9ec;
	border-radius: 10px;
	padding: 10px 16px;
	text-align: center;
}

.mayor-kpi--final {
	background: #fdf3f4;
	border-color: #f3ced2;
}

.mayor-kpi__valor {
	display: block;
	font-size: 19px;
	font-weight: 700;
	font-variant-numeric: tabular-nums;
	margin-top: 4px;
}

.mayor-positivo {
	color: #0e6b63;
}

.mayor-negativo {
	color: #c62828;
}

/* ---------------- barra de filtros ---------------- */

.mayor-filtros {
	align-items: flex-end;
	background: #f6f8f9;
	border-bottom: 1px solid #e6ebee;
	display: flex;
	gap: 16px;
	padding: 14px 28px;
}

.mayor-campo {
	display: flex;
	flex-direction: column;
	gap: 5px;
	min-width: 0;
}

.mayor-campo--buscar {
	flex: 1 1 auto;
}

.mayor-control {
	align-items: center;
	background: #ffffff;
	border: 1px solid #dde4e8;
	border-radius: 8px;
	display: flex;
	gap: 8px;
	height: 36px;
	padding: 0 12px;
}

.mayor-control--periodo {
	width: 230px;
}

.mayor-control--ver {
	width: 160px;
}

.mayor-control input,
.mayor-control select {
	background: transparent;
	border: none;
	color: #3d4b55;
	font-family: inherit;
	font-size: 12.5px;
	outline: none;
	width: 100%;
}

.mayor-control .v-icon {
	color: #8a97a1 !important;
	font-size: 17px !important;
}

.mayor-acciones {
	display: flex;
	gap: 10px;
	margin-left: auto;
}

.mayor-btn {
	align-items: center;
	border-radius: 8px;
	cursor: pointer;
	display: inline-flex;
	font-family: inherit;
	font-size: 12.5px;
	font-weight: 600;
	gap: 7px;
	height: 36px;
	padding: 0 16px;
}

.mayor-btn--linea {
	background: #ffffff;
	border: 1px solid #dde4e8;
	color: #3d4b55;
}

.mayor-btn--linea:hover {
	background: #eef2f4;
}

.mayor-btn--solido {
	background: #0e6b63;
	border: none;
	color: #ffffff;
}

.mayor-btn--solido:hover {
	background: #0a5a55;
}

.mayor-btn .v-icon {
	font-size: 16px !important;
}

.mayor-btn--linea .v-icon {
	color: #3d4b55 !important;
}

.mayor-btn--solido .v-icon {
	color: #ffffff !important;
}

/* ---------------- tabla ---------------- */

.mayor-tabla {
	padding: 0 28px;
}

.mayor-grid {
	display: grid;
	grid-template-columns: 110px 180px minmax(150px, 0.9fr) minmax(220px, 1.6fr) 120px 120px 150px;
}

.mayor-grid--sin-desc {
	grid-template-columns: 110px 190px minmax(220px, 1fr) 140px 140px 160px;
}

.mayor-thead {
	background: #f6f8f9;
	border: 1px solid #e6ebee;
	border-radius: 8px 8px 0 0;
}

.mayor-thead .mayor-celda {
	color: #78848e;
	font-size: 10.5px;
	font-weight: 700;
	height: 40px;
	letter-spacing: 0.6px;
	text-transform: uppercase;
}

.mayor-tbody {
	border: 1px solid #e6ebee;
	border-top: none;
	border-radius: 0 0 8px 8px;
	max-height: 360px;
	overflow-y: auto;
}

.mayor-fila {
	border-bottom: 1px solid #eef2f4;
	transition: background-color 0.12s;
}

.mayor-fila:last-child {
	border-bottom: none;
}

.mayor-fila:hover {
	background: #f6fbfa;
}

.mayor-fila--inicial {
	background: #fbfcfd;
}

.mayor-celda {
	align-items: center;
	color: #45515e;
	display: flex;
	font-size: 12.5px;
	min-height: 44px;
	min-width: 0;
	padding: 8px 12px;
}

.mayor-celda--num {
	font-variant-numeric: tabular-nums;
	justify-content: flex-end;
	text-align: right;
	white-space: nowrap;
}

.mayor-celda--saldo {
	font-weight: 700;
}

.mayor-texto {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mayor-asiento {
	color: #0e6b63;
	font-weight: 600;
	text-decoration: underline;
}

.mayor-fecha-inicial {
	text-decoration: underline;
}

.mayor-conteo {
	color: #8a97a1;
	font-size: 11.5px;
	padding: 8px 2px 0;
}

.mayor-vacio {
	align-items: center;
	color: #9aa5b1;
	display: flex;
	flex-direction: column;
	font-size: 13px;
	gap: 6px;
	justify-content: center;
	min-height: 200px;
}

/* ---------------- resumen inferior ---------------- */

.mayor-resumen-pie {
	align-items: stretch;
	display: flex;
	gap: 14px;
	padding: 16px 28px 0;
}

.mayor-periodo {
	background: #f6f8f9;
	border: 1px solid #e6ebee;
	border-radius: 10px;
	flex: 0 0 auto;
	padding: 12px 18px;
}

.mayor-periodo__titulo {
	color: #16222b;
	font-size: 12.5px;
	font-weight: 700;
	letter-spacing: 0.4px;
	text-transform: uppercase;
}

.mayor-periodo__rango {
	align-items: center;
	color: #66727e;
	display: flex;
	font-size: 12px;
	gap: 6px;
	margin-top: 6px;
}

.mayor-periodo__rango .v-icon {
	color: #8a97a1 !important;
	font-size: 15px !important;
}

.mayor-operacion {
	align-items: center;
	color: #8a97a1;
	display: flex;
	font-size: 18px;
	font-weight: 700;
}

.mayor-caja {
	background: #ffffff;
	border: 1px solid #e3e9ec;
	border-radius: 10px;
	flex: 1 1 0;
	padding: 12px 16px;
	text-align: center;
}

.mayor-caja--final {
	background: #fdf3f4;
	border-color: #f3ced2;
}

.mayor-caja__valor {
	display: block;
	font-size: 19px;
	font-weight: 700;
	font-variant-numeric: tabular-nums;
	margin-top: 4px;
}

.mayor-nota {
	align-items: center;
	color: #8a97a1;
	display: flex;
	font-size: 11.5px;
	gap: 8px;
	justify-content: space-between;
	padding: 14px 28px 18px;
}

.mayor-nota__izq {
	align-items: center;
	display: flex;
	gap: 7px;
}

.mayor-nota .v-icon {
	color: #8a97a1 !important;
	font-size: 15px !important;
}

.mayor-formula {
	align-items: center;
	display: flex;
	gap: 5px;
}

/* ---------------- scrollbar ---------------- */

.mayor-tbody::-webkit-scrollbar {
	width: 7px;
}

.mayor-tbody::-webkit-scrollbar-track {
	background: #f1f3f6;
}

.mayor-tbody::-webkit-scrollbar-thumb {
	background: #c3ccd4;
	border-radius: 10px;
}

.mayor-tbody::-webkit-scrollbar-thumb:hover {
	background: #9aa5b1;
}

/* ---------------- responsive ---------------- */

@media (max-width: 1100px) {
	.mayor-resumen {
		align-items: stretch;
		flex-direction: column;
	}

	.mayor-kpis {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.mayor-filtros {
		flex-wrap: wrap;
	}

	.mayor-resumen-pie {
		flex-wrap: wrap;
	}

	.mayor-operacion {
		display: none;
	}
}

/* =====================================================
   RESPONSIVE
===================================================== */

@media (max-width: 900px) {

  .mayor-info {
    grid-template-columns:
      1fr
      1fr;
  }

  .mayor-info-item {
    border-bottom:
      1px solid rgba(255, 255, 255, 0.12);
  }

}


@media (max-width: 600px) {

  .mayor-header-content {
    padding: 14px 16px;
  }

  .mayor-title {
    font-size: 20px;
  }

  .mayor-info {
    grid-template-columns: 1fr;
  }

  .mayor-info-item {
    min-height: 55px;

    border-right: none;
  }

  .mayor-table-body {
    height: 380px;
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/reports/general-reports.vue